import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagePartnerComponent } from './manage-partner.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromManageusersPartner from '../manageusers/+state/manageusers.reducer';
import { ManageusersEffects } from '../manageusers/+state/manageusers.effects';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreUiModule } from '@pos-app/core-ui';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatIconModule } from '@angular/material/icon';

import { CustomersModule } from '../customers/customers.module';
import { PartnerProgramComponent } from './manage-partner-program/partnerprogram.component';
import { ManagePartnerEnrollment } from './components/manage-partner-enrollment/manage-partner-enrollment.component';

@NgModule({
    imports: [
        CustomersModule,
        CommonModule,
        NgbModule,
        FormsModule,
        CoreUiModule,
        ReactiveFormsModule,
        NgSelectModule,
        MatIconModule,
        StoreModule.forFeature(fromManageusersPartner.MANAGEUSERS_FEATURE_KEY, fromManageusersPartner.reducer),
        EffectsModule.forFeature([ManageusersEffects]),
        ManagePartnerComponent, PartnerProgramComponent, ManagePartnerEnrollment,
    ],
})
export class ManagepartnerModule {}

